import styled from 'styled-components';

export const Image = styled.img`
  border-radius: 8px;
`;

export const Container = styled.div`
  min-height: 40vh;
  display: flex;
  align-items: center;
  justify-content: center;

  .image-gallery-thumbnails .image-gallery-thumbnails-container {
    display: flex;
  }

  .image-gallery-thumbnail {
    border-radius: 12px;
    overflow: hidden;
    border: 2px solid transparent;
  }

  .image-gallery-thumbnail.active,
  .image-gallery-thumbnail:hover,
  .image-gallery-thumbnail:focus {
    border: 2px solid ${(props) => props.theme.PRIMARY_COLOR};
    box-shadow: 0px 3px 10px 0px ${(props) => props.theme.COLOR_BOX_SHADOW};
  }
`;
